import ethBase from "@/lib/eth/ethCall/base";
import {ethers} from "ethers";
import config from "@/config";

let erc20Contract
let erc20WithSigner

function init(){
    if (!erc20Contract || !erc20WithSigner) {
        const {provider, signer} = ethBase.getEthProviderAndSigner()

        erc20Contract = new ethers.Contract(
            config.blockchainConfig.contractAddresses.stablecoin,
            config.contractAbi.erc20,
            provider
        )

        erc20WithSigner = erc20Contract.connect(signer)
    }
}

async function approve(amount) {
    if (!erc20WithSigner) {
        init()
    }
    const tx = await erc20WithSigner.approve(
        config.blockchainConfig.contractAddresses.storeFactory,
        amount
    );
    return await tx.wait()
}

async function getBalance(account) {
    if (!erc20Contract) {
        init()
    }
    return await erc20Contract.balanceOf(account)
}

async function getAllowance(owner) {
    if (!erc20Contract) {
        init()
    }
    return await erc20Contract.allowance(owner, config.blockchainConfig.contractAddresses.storeFactory)
}

export default {
    approve,
    getBalance,
    getAllowance
}

